import { useEffect } from 'react';

function useOnClickEscape(active, callback) {
    useEffect(() => {
        if (!active) {
            return;
        }

        function onKeyDown(e) {
            if (e.key.toLowerCase() === 'escape') {
                callback();
            }
        }

        document.body.addEventListener('keydown', onKeyDown);

        return () => {
            document.body.removeEventListener('keydown', onKeyDown);
        };
    }, [active, callback]);
}

export { useOnClickEscape };
